import { Component, Input } from '@angular/core';
import {
	LimiteGlobal,
	LimiteGlobalRetornoGarantiaVeiculo,
} from '../../models/limite-global';

@Component({
	selector: 'app-card-garantia-lg',
	templateUrl: './card-garantia-lg.component.html',
	styleUrls: ['./card-garantia-lg.component.styl'],
})
export class CardGarantiaLgComponent {
	@Input() limiteGlobal: LimiteGlobal;

	constructor() {}

	public get garantiaVeiculo(): LimiteGlobalRetornoGarantiaVeiculo {
		return this.limiteGlobal.GarantiaVeiculo;
	}

	public get marcaModelo(): string {
		return `${this.limiteGlobal.GarantiaVeiculo.Marca} ${this.limiteGlobal.GarantiaVeiculo.Modelo}`;
	}

	public get descricaoCompleta(): string {
		return `${this.limiteGlobal.GarantiaVeiculo.Versao} ${this.limiteGlobal.GarantiaVeiculo.AnoModelo} ${this.limiteGlobal.GarantiaVeiculo.Combustivel}`;
	}

	public get fipe(): number {
		return Number(this.limiteGlobal.GarantiaVeiculo.Fipe);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/components/card-garantia-lg/card-garantia-lg.component.ts